import { DataTable } from '../../models';
import { trimMetricTable } from './trimMetricTable';

export enum DateWindowTypes {
  LAST_N = 'last-n',
  SPECIAL = 'special',
  LATEST_DATA = 'latest-data',
  CUSTOM = 'custom',
  DEFINED_START = 'defined-start',
}

export type DateWindowFunction = (table: DataTable) => DataTable;

export const applyWindowFunction = (table: DataTable, func: DateWindowFunction): DataTable => {
  return applyMaxWindow(func(table));
};

export const applyMaxWindow = (table: DataTable) => {
  return trimMetricTable(table, 1000);
};
